module.exports = __webpack_public_path__ + "img/2729404.jpg";